import React from 'react';
import { useSelector } from 'react-redux';
import { Badge } from "../../ui/badge";
import { Card, CardContent } from "../../ui/card";
import { Loader, AlertTriangle, Clock } from "lucide-react";

const RecentIssues = ({ onRowClick }) => {
  const { latestIssues, latestIssuesLoading } = useSelector(state => state.UserIssuesLogs);

  const getIssuePriorityVariant = (severity) => {
    switch (severity?.toLowerCase()) {
      case 'critical':
      case 'significant':
        return 'destructive';

      case 'moderate':
        return 'warning';

      default:
        return 'default'
    }
  }

  const getIssueStatusVariant = (status) => {
    switch (status?.toLowerCase()) {
      case 'reported':
      case 'detected':
        return 'outline';
      
      case 'handling':
        return 'secondary';

      default:
        return 'success';
    }
  }

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center gap-2 mb-4">
          {latestIssuesLoading && (<Loader className="h-5 w-5 text-amber-500 animate-spin"/>)}
          {!latestIssuesLoading && (<AlertTriangle className="h-5 w-5 text-amber-500" />)}
          <h3 className="font-semibold text-lg">
            Recent Issues
          </h3>
        </div>
        <p className="text-sm text-gray-500 mb-4">
          Latest reported problems that require attention
        </p>

        {latestIssues?.issues?.length > 0 ? (
          <div className="space-y-3">
            {latestIssues?.issues?.map((issue, index) => (
              <div key={index} className="border p-3 rounded-md cursor-pointer hover:bg-gray-50 transition" onClick={() => onRowClick(issue.id)}>
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                  <div>
                    <div className="flex items-center gap-2">
                      <Badge variant={getIssuePriorityVariant(issue.severity)}>
                        {issue.severity}
                      </Badge>
                      <span className="text-sm font-medium">{issue.category}</span>
                    </div>
                    <p className="text-sm mt-1">{issue.type}</p>
                  </div>
                  <div className="flex flex-col items-start sm:items-end">
                    <Badge variant={getIssueStatusVariant(issue.status)}>
                      {issue.status}
                    </Badge>
                    <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
                      <Clock className="h-3 w-3" />
                      <span>{issue.start}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-6 text-gray-500">
            <p>No recent issues reported</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentIssues;
